/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import type * as Types from '@sg/graphql-schema';

import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type IdentifyAndClaimInStoreOrderMutationVariables = Types.Exact<{
  input: Types.IdentifyAndClaimInStoreOrderInput;
}>;

export type IdentifyAndClaimInStoreOrderMutation = {
  readonly __typename?: 'Mutation';
  readonly identifyAndClaimInStoreOrder:
    | {
        readonly __typename: 'IdentifyAndClaimInStoreOrderSuccess';
        readonly success: boolean;
      }
    | {
        readonly __typename: 'ReceiptAlreadyClaimedError';
        readonly errorMessage: string;
      }
    | {
        readonly __typename: 'TimeRestrictionError';
        readonly errorMessage: string;
      }
    | {
        readonly __typename: 'TransactionNotFoundError';
        readonly errorMessage: string;
      };
};

export const IdentifyAndClaimInStoreOrderDocument = gql`
  mutation IdentifyAndClaimInStoreOrder(
    $input: IdentifyAndClaimInStoreOrderInput!
  ) {
    identifyAndClaimInStoreOrder(input: $input) {
      __typename
      ... on IdentifyAndClaimInStoreOrderSuccess {
        success
      }
      ... on TimeRestrictionError {
        errorMessage
      }
      ... on ReceiptAlreadyClaimedError {
        errorMessage
      }
      ... on TransactionNotFoundError {
        errorMessage
      }
    }
  }
`;

export function useIdentifyAndClaimInStoreOrderMutation() {
  return Urql.useMutation<
    IdentifyAndClaimInStoreOrderMutation,
    IdentifyAndClaimInStoreOrderMutationVariables
  >(IdentifyAndClaimInStoreOrderDocument);
}
